import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { usePopupStore, useViewSettingsStore } from "..";
import PopupType from "../interfaces/PopupType";

export default function useNavigateToProperty(): (longitude: number, latitude: number, forceDetails?: boolean) => void {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const popupStore = usePopupStore();
    const viewSettingsStore = useViewSettingsStore();

    return useCallback((longitude: number, latitude: number, forceDetails: boolean = false) => {
        const isPopupAlreadyOpen = popupStore.longitude === longitude && popupStore.latitude === latitude && popupStore.type === PopupType.Property;
        if (pathname !== `/property/${longitude}/${latitude}` && (isPopupAlreadyOpen || forceDetails || viewSettingsStore.isMobile))
            navigate(`/property/${longitude}/${latitude}`);
        else
            popupStore.openPropertyPopup(longitude, latitude);
    }, [popupStore.id, popupStore.type, pathname]);
}